import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { MapPin, Phone, Clock, Navigation } from "lucide-react";
import { api } from "@/lib/api";
import { PageHeader, Spinner } from "@/components/common";
import { useMeta } from "@/hooks/useMeta";

export default function Stores() {
  const [stores, setStores] = useState<any[] | null>(null);
  const [active, setActive] = useState(0);
  useMeta("Showrooms | Somnio.Co", "Visit a Somnio.Co showroom by appointment.");
  useEffect(() => { api.get("/stores").then((r) => setStores(r.data)); }, []);
  if (!stores) return <Spinner />;
  const s = stores[active];
  const bbox = s ? `${s.lng - 0.02},${s.lat - 0.012},${s.lng + 0.02},${s.lat + 0.012}` : "";
  return (
    <div data-testid="stores-page">
      <PageHeader eyebrow="Visit Us" title={stores.length === 1 ? stores[0].name : "Showrooms"} intro="Experience our collections in person. All boutique visits are by appointment." />
      <div className="max-w-[1400px] mx-auto px-5 md:px-12 grid lg:grid-cols-[420px_1fr] gap-10">
        <div className="space-y-4">
          {stores.map((x, i) => (
            <button key={x.id} onClick={() => setActive(i)} data-testid={`store-card-${x.slug}`} className={`w-full text-left p-7 border transition-colors ${i === active ? "border-neutral-900 bg-white" : "border-neutral-200 hover:border-neutral-400"}`}>
              <p className="font-display text-2xl">{x.name}</p>
              <p className="text-sm text-neutral-600 mt-3 flex gap-2"><MapPin size={16} strokeWidth={1.2} />{x.address}, {x.city}</p>
              {x.phone && <a href={`tel:${x.phone.replace(/[^+\d]/g, "")}`} onClick={(e) => e.stopPropagation()} className="text-sm text-neutral-600 mt-2 flex gap-2 hover:underline" data-testid={`store-phone-${x.slug}`}><Phone size={16} strokeWidth={1.2} />{x.phone}</a>}
              <p className="text-sm text-neutral-600 mt-2 flex gap-2"><Clock size={16} strokeWidth={1.2} />{x.hours}</p>
              <div className="mt-5 flex flex-wrap gap-x-6 gap-y-2">
                <Link to="/consultation" className="eyebrow underline" data-testid={`store-book-${x.slug}`}>Book an appointment</Link>
                <a href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(`${x.address}, ${x.city}`)}`} target="_blank" rel="noreferrer" onClick={(e) => e.stopPropagation()} className="eyebrow underline inline-flex items-center gap-1.5" data-testid={`store-directions-${x.slug}`}><Navigation size={12} strokeWidth={1.4} />Get directions</a>
              </div>
            </button>
          ))}
        </div>
        {s && <iframe title="map" className="w-full h-[420px] lg:h-full min-h-[420px] border border-neutral-200 grayscale" data-testid="store-map"
          src={`https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${s.lat},${s.lng}`} />}
      </div>
    </div>
  );
}
